import { useEffect, useState } from "react";
import { liveSession } from "@/lib/liveSession";

export function useLiveSession() {
  const [snap, setSnap] = useState(liveSession.snapshot());
  useEffect(() => liveSession.subscribe(setSnap), []);
  return snap;
}
